import { AUTH0_TENANT_CLAIM } from 'app/constants';

export const ApiInterceptorModule = angular
    .module('app.services.interceptors.apiInterceptor', []).factory('apiInterceptor', (
        $q,
        auth0AuthService,
        jwtHelper
    ) => {
        function shouldNotIntercept(url) {
            const baseUrl = process.env.BASE_API_URL;
            const themeUrl = `${baseUrl}/marketplace`;
            const customDomainUrl = `${baseUrl}/admin/customdomains`;

            return (url.indexOf(baseUrl) === -1 &&
                    url.indexOf(themeUrl) === -1 &&
                    url.indexOf(process.env.EXPIRE_CACHE_URL) === -1 &&
                    url.indexOf(process.env.ONBOARDING_API_URL) === -1 &&
                    url.indexOf(customDomainUrl) === -1) ||
                url.indexOf(`${baseUrl}/plans`) !== -1;
        }

        function getDecodedJWT(token) {
            if (token) {
                return jwtHelper.decodeToken(token);
            }
            return null;
        }

        function getTenantId(decoded) {
            if (decoded) {
                const tenantId = decoded[AUTH0_TENANT_CLAIM] || decoded.tenant;
                return tenantId;
            }
        }

        return {
            requestError(rejection) {
                return $q.reject(rejection);
            },

            responseError(rejection) {
                if (rejection.status === 403
                    && rejection.config.url
                    && rejection.config.url.includes(process.env.BASE_API_URL)
                ) {
                    return auth0AuthService.unauthenticatedHandler();
                }

                return $q.reject(rejection);
            },

            request: (config) => {
                if (shouldNotIntercept(config.url)) return config;
                return auth0AuthService.getTokenSilently().then((accessToken) => {
                    if (!config.bypassAuth) {
                        config.headers.Authorization = `Bearer ${accessToken}`;
                    }

                    const decoded = getDecodedJWT(accessToken);
                    const tenantId = getTenantId(decoded);
                    config.headers['x-mat-tenant'] = tenantId;

                    return config;
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/interceptors/api.interceptor.js